export default __webpack_public_path__ + "static/tetris-preview-mb-3-5efff522b8cd73208220e2b7dcc884dd.png";